import { FC, ReactNode } from "react";
import { Box, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import theme from "theme";

const rowHeight = "40px";
const useStyles = makeStyles(theme => ({
  row: {
    height: rowHeight,
    "& .MuiTableCell-root": {
      padding: `${theme.spacing(1)}px 0 ${theme.spacing(1)}px 0`,
    },
    "&:last-child": {
      "& .MuiTableCell-root": {
        borderBottom: "none",
      },
    },
  },
  rowTitle: {
    fontSize: "1rem",
    fontWeight: theme.typography.fontWeightMedium,
  },
  rowData: {
    fontSize: "0.9rem",
    fontWeight: 700,
    textAlign: "right",
  },
}));

export interface DetailsTableRow {
  title: string;
  data: ReactNode;
  spacerAfterRow?: boolean;
}
interface DetailsTableProps {
  rows: DetailsTableRow[];
}

const DetailsTable: FC<DetailsTableProps> = ({ rows }) => {
  const classes = useStyles(theme);
  return (
    <Table>
      <TableBody>
        {rows.map(row => (
          <TableRow key={row.title} className={classes.row}>
            <TableCell>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                style={
                  row.spacerAfterRow
                    ? {
                        marginBottom: `${rowHeight}`,
                      }
                    : undefined
                }
              >
                <Box className={classes.rowTitle}>{row.title}</Box>
                <Box className={classes.rowData}>{row.data}</Box>
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default DetailsTable;
